import { IAuditLogDto } from "../dto";
import { getCompanyId } from "../helpers";
import { RydeUiUnit } from "../models";
import { apiGetAll } from "./generic-api";

interface IGetLogByIdParams {
  id: number;
  entity: RydeUiUnit;
  abortController?: AbortController;
}

export class AuditLogApi {
  static async getLogById({
    id,
    entity,
    abortController,
  }: IGetLogByIdParams): Promise<IAuditLogDto[] | undefined> {
    const companyId = getCompanyId();
    const response = await apiGetAll<IAuditLogDto>(
      `/api/v1/core/c/${companyId}/auditLogs/${id}`,
      {
        body: { subject_entity: entity },
        controller: abortController,
      },
    );
    return response;
  }
}
